import { FetchPatientTreatmentListRequestPayload } from "@/data/payload/treatment/fetch-patient-treatement-list-request-payload";
import { PatientTreatmentTotalInfoEntity } from "@/domain/entity/treatment/patient-treatment-total-info-entity";
import { TreatmentRepository } from "@/domain/repository/treatment-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class FetchPatientTotalTreatmentListUsecase {
  //MARK:- Constructor
  constructor(private readonly treatmentRepo: TreatmentRepository) {}

  //MARK:- execute
  async execute(
    patientUuid: string
  ): Promise<SATResult<PatientTreatmentTotalInfoEntity, SATError>> {
    const payload: FetchPatientTreatmentListRequestPayload = {
      patientUuid,
    };

    const result = await this.treatmentRepo.fetchPatientTreatmentList(payload);

    if (result.isFailure) {
      return SATResult.failure(result.error);
    }

    return SATResult.success(result.value);
  }
}
